import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import type { CreateProductAdjustment } from "../types/ProductAdjustment";
import {
  GET_PRODUCT_ADJUSTMENTS_FETCH_KEY,
  ProductAdjustment,
} from "@/shared/core-product-adjustments";
import { AxiosError } from "axios";

export const editProductAdjustment = async (
  id: string,
  productAdjustmentData: Partial<CreateProductAdjustment>,
): Promise<ProductAdjustment> => {
  try {
    console.log("Datos enviados al servidor:", productAdjustmentData);

    const response = await fetcher.put(
      `${API.GESLUB}/product-adjustments/${id}`,
      productAdjustmentData,
    );

    console.log("Respuesta del servidor:", response);

    return response.data as ProductAdjustment;
  } catch (error) {
    console.error(
      "Error en la solicitud de edición de ajuste de producto",
      error,
    );
    throw error;
  }
};

export const useEditProductAdjustment = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ProductAdjustment,
    AxiosError<{ message: string }>,
    { id: string; productAdjustmentData: Partial<CreateProductAdjustment> }
  >({
    mutationFn: ({ id, productAdjustmentData }) =>
      editProductAdjustment(id, productAdjustmentData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PRODUCT_ADJUSTMENTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
